module.exports = __webpack_public_path__ + "img/vcr_icon.a4a6999e.svg";